import { ModalCustom } from "components/ModalCustom";
import { FaExclamation } from "react-icons/fa";
import { Corpo, Icone } from "../../components/ModalRetorno/style";

interface IProps {
  show: boolean;
  titulo: string;
  quantidade: number;
  nomeDestino: string;
  carregando: boolean;
  onCancelar: () => void;
  onConfirmar: () => void;
}

export function MoverTipoModal({
  show,
  titulo,
  quantidade,
  nomeDestino,
  carregando,
  onCancelar,
  onConfirmar,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={carregando ? () => {} : onCancelar}
      title={titulo}
      centered
      footer
      footerConfirmButton
      confirmButtonText="Mover"
      onConfirm={onConfirmar}
      disabledConfirmButton={carregando}
    >
      <Corpo>
        <Icone $tipo="aviso">
          <FaExclamation />
        </Icone>
        Deseja mover <strong>{quantidade} placa(s)</strong> para{" "}
        <strong>{nomeDestino}</strong>?
      </Corpo>
    </ModalCustom>
  );
}
